import { get } from 'lodash-es';
import { connect } from 'react-redux';
import Player from '../components/Player';
import { areHotspotsLoaded, areInitialScreensPreloaded, getExternalPrototypeUrl, isInHandoffMode, } from '../selectors';
import { isPlaying } from '../selectors/player';
var mapStateToProps = function (state) { return ({
    isInHandoffMode: isInHandoffMode(state),
    isPlaying: isPlaying(state),
    areInitialScreensPreloaded: areInitialScreensPreloaded(state),
    areHotspotsLoaded: areHotspotsLoaded(state),
    transition: state.screen.transition,
    backgroundColor: state.project.config.screenBackgroundColour,
    isEmpty: get(state, 'project.config.screens.length') === 0,
    externalPrototypeUrl: getExternalPrototypeUrl(state),
}); };
export default connect(mapStateToProps, null)(Player);
